<div class="back-btn" (click)="onClick()">
    <div class="icon-smash_back back-icon"></div>
    <div>{{'BACK' | translate}}</div>
</div>